export default "__VITE_ASSET__lvaB6Ln$__"